import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default function Disclaimer(props) {
	const { sizeOfFont, disclaimerVisibility } = props;

	const [sizeOfFontSmall, setSizeOfFontSmall] = useState(
		multiplyPercentageBy(0.8)
	);

	useEffect(() => {
		setSizeOfFontSmall(multiplyPercentageBy(0.8));
		// console.log("reset disclaimer font size: now ", sizeOfFontSmall);
	}, [sizeOfFont]);

	/**
	 * Multiply sizeOfFont by x.
	 * @param {number} x
	 * @returns The string representation of the result.
	 */
	function multiplyPercentageBy(x) {
		let p = parseFloat(sizeOfFont) * x;
		return p + "%";
	}

	return (
		<footer
			id="disclaimer"
			style={{ fontSize: sizeOfFontSmall, display: disclaimerVisibility }}
		>
			<div>
				<hr />
				<p>
					This application is created with{" "}
					<a
						href="https://github.com/axios/axios"
						target="_blank"
						rel="noreferrer"
					>
						Axios
					</a>
					,{" "}
					<a
						href="https://reactjs.org/"
						target="_blank"
						rel="noreferrer"
					>
						ReactJS
					</a>
					,{" "}
					<a
						href="https://react-bootstrap.github.io/"
						target="_blank"
						rel="noreferrer"
					>
						React-Bootstrap
					</a>{" "}
					and{" "}
					<a
						href="https://react-icons.github.io/react-icons/"
						target="_blank"
						rel="noreferrer"
					>
						React-Icons
					</a>
					. Quiz questions are downloaded from the{" "}
					<a
						href="https://opentdb.com/"
						target="_blank"
						rel="noreferrer"
					>
						Open Trivia Database
					</a>
					, and are generated by users. <br />
					Created with{" "}
					<OverlayTrigger
						placement="top"
						overlay={<Tooltip>Why hello there.</Tooltip>}
					>
						<span>&#10084;</span>
					</OverlayTrigger>{" "}
					by Mingrui "Myron" Ma on March 2021. Source code can be
					found on{" "}
					<a
						href="https://github.com/Mingrui-Ma/my-quiz-app"
						target="_blank"
						rel="noreferrer"
					>
						GitHub
					</a>
					.
				</p>
			</div>
		</footer>
	);
}
